export default __webpack_public_path__ + "static/media/friendometer1.ca1672cf.jpg";